module.exports = __webpack_public_path__ + "static/media/ZSMC.8299420f.pdf";